import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { RegistrationPopupComponent } from '../registrationPopup/registrationPopup.component';
import { MatDialog } from '@angular/material/dialog';
import { ResetpasswordComponent } from '../../resetpassword/resetpassword.component';



@Component({
  selector: 'div.dtf-fawlogin',
  imports: [SharedTranslateModule],
  templateUrl: './fawlogin.component.html',
  providers: [
    //  ClassesUtil, WindowRef
  ]
})

export class FawLoginComponent implements OnInit {
  title = 'FawLogin';
  usUrl = '';
  source = '';
  agentId = '';
  language = '';
  authToken = '';
  identifier = '';
  brandId = '';
  SSN = '';
  emailid= '';
  serviceErrorOccurred = false;
  serviceErrorDesc = '';

  isAuthenticated = false;
  constructor(
    public router: Router,
    public auth: AuthorizationService,
    private windowRef: WindowRef,
    public translate: TranslateService,
    public dialog: MatDialog
  ) {

  }
  ngOnInit() {
    sessionStorage.clear(); //clears all sessionStorage Objects
    const mbfs = this.windowRef.nativeWindow?.mbfs || {};
    this.usUrl = mbfs.usUrl;
    this.source = mbfs.source;
    this.agentId = mbfs.agentId;
    this.authToken = mbfs.authToken;
    this.identifier = mbfs.identifier;
    this.SSN = mbfs.SSN;
    this.emailid = mbfs.emailid;
    this.language = mbfs.language;
    sessionStorage.setItem('agentview', 'true');
    const fawDataRequest = {
      'source': this.source,
      'agentId': this.agentId,
      'authToken': this.authToken,
      'identifier': this.identifier,
      'ssn': this.SSN,
      'emailid': this.emailid
    };
    this.fawLoginCall(fawDataRequest);
  }

  fawLoginCall(fawDataRequest) {
    this.auth.decryptFawToken(fawDataRequest).subscribe(res => {
      JSON.stringify(res);
      sessionStorage.setItem('identifier', res.userId);
      sessionStorage.setItem('fedId', res.ssn);
      sessionStorage.setItem('email', res.emailAddress);
      sessionStorage.setItem('agentId',  res.agentId);

      //if ssn == null or empty then open registration popup else continue with login
      if (res?.userValid && res?.token && this.SSN?.trim() == '') {
        sessionStorage.setItem("username", res.userId);
        this.auth.getAuthToken().subscribe(authRes => {
          sessionStorage.setItem("Authorization", authRes.token);
          sessionStorage.setItem("userId", authRes.userId);
          this.brandId = res.brandId.toString();
          sessionStorage.setItem('auth', 'yes');
          this.auth.istoken = res.token;
          sessionStorage.setItem('loginID', res.userId);
          sessionStorage.setItem('agentview', 'true');
          sessionStorage.setItem('agentID', res.agentId);
          sessionStorage.setItem('ciamToken', this.auth.istoken);
          sessionStorage.setItem('brandId', this.brandId);
          sessionStorage.setItem('classicredirect', 'no');
          sessionStorage.setItem('forward', res.forward);
          sessionStorage.setItem('thirdPartyNumber', res.thirdPartyNumber);
          sessionStorage.setItem('customerName', res.customerName);
          sessionStorage.setItem('emailAddress', res.emailAddress);
          sessionStorage.setItem('loginID', res.userId);

          this.auth.isAuthenticated(); // Checks if user is authenticated
          const path = this.brandId === '3' ? '/ca/en/home/dashboard' : '/home/dashboard';
          this.windowRef.nativeWindow.location.href = `${this.usUrl}${path}`;
        });
      } else if (res.userValid === false && res.token === null && this.SSN && this.SSN.trim() !== '') {
        this.dialog.open(RegistrationPopupComponent, {
          maxWidth: '500vw',
          width: '1000px',
        });
        this.serviceErrorDesc ="";
      this.serviceErrorOccurred = true;
        //  this.dialog.open(ResetpasswordComponent, {
        //   maxWidth: '500vw',
        //   width: '1000px',
        // });
        // this.serviceErrorOccurred = true;
      } else {
        // If checks to load BE error messages based on language
        const messageMap: Record<string, string> = {
          'en-CA': res?.status?.message?.shortMessage_EN,
          'fr-CA': res?.status?.message?.shortMessage_FR
        };

        this.serviceErrorDesc =
          messageMap[this.language] || res?.status?.message?.shortMessage;

        this.serviceErrorOccurred = true;
      }
    });
  }
}
